"use client";

import { useRouter } from "next/navigation";
import { useAuth } from "@/hooks/useAuth";
import { ArrowRight } from "lucide-react";

/** Canonical post-signup destination. */
const COPY_URL = "/copytrading";
const TRADERS_URL = "/traders";

/**
 * Primary hero CTAs. Mobile: side-by-side.
 *
 *  - Start trading: always a <button>. At click time we check auth:
 *      logged out → fire Privy `login()` directly — same flow as the
 *                   header Sign In button. No intermediate modal.
 *      logged in  → router.push to /polymarket/markets/trending
 *  - Explore markets: always deep-links to /polymarket/markets/trending.
 */
export default function HeroV3CTA() {
  const router = useRouter();
  const { isLoggedIn, login } = useAuth();

  const onStart = () => {
    if (isLoggedIn) {
      router.push(COPY_URL);
    } else {
      login();
    }
  };

  return (
    <div className="flex flex-row items-center gap-3 justify-center lg:justify-start">
      <button
        type="button"
        onClick={onStart}
        className="group inline-flex items-center gap-2 px-5 sm:px-6 py-3 sm:py-3.5 rounded-[5px] bg-gray-900 dark:bg-white text-white dark:text-gray-900 font-inter-tight font-medium text-sm sm:text-[15px] hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors"
      >
        Start copying
        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
      </button>
      <button
        type="button"
        onClick={() => router.push(TRADERS_URL)}
        className="inline-flex items-center gap-2 px-5 sm:px-6 py-3 sm:py-3.5 rounded-[5px] border border-gray-200 dark:border-white/10 text-gray-700 dark:text-gray-200 font-inter-tight font-medium text-sm sm:text-[15px] hover:bg-gray-50 dark:hover:bg-white/[0.04] transition-colors"
      >
        See top traders
      </button>
    </div>
  );
}
